import { createSearchStore } from '@/stores/create-search-store';
import { getTodayDateString } from '@/utils/date-time';

export const usePlanSearchStore = createSearchStore({
  storeName: 'PlanSearchStore',
  defaultSortField: 'placementDate',
  defaultSortOrder: 'asc',
  defaultItemsPerPage: 100,
  defaultSearchValues: {
    placementDateFrom: getTodayDateString(),
  },
});
